import { Component } from '@angular/core';

@Component({
  selector: 'app-cookie-policy',
  standalone: false,
  templateUrl: './cookie-policy.html',
  styleUrls: ['../legal.css']
})
export class CookiePolicy {
  lastUpdated = 'December 6, 2025';
}
